import { useConfig } from '../hooks';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { Timer } from '~components/battlePass';

export const BattlePassBanner = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const getConfig = useConfig();
  const getBattlePass = getConfig?.getBattlePass;

  if (!getBattlePass) {
    return null;
  }

  return (
    <>
      <video
        width="320"
        height="240"
        preload="auto"
        controls={false}
        autoPlay
        loop
        playsInline
        muted
      >
        <source src={getBattlePass?.props?.background} type="video/mp4" />
        <source src={getBattlePass?.props?.background} type="video/ogg" />
      </video>
      <section>
        <div className="breezy-home-content">
          <Timer
            endDate={getBattlePass.endDate}
            isEndend={getBattlePass?.isEndend}
            isStart={getBattlePass?.isStart}
            isLaunched={getBattlePass?.isLaunched}
            nameImage={getBattlePass?.props?.nameImage}
          />
          <div
            className="breezy-home-title"
            style={{
              background: `url(${getBattlePass.props?.nameImage}) no-repeat 0 0`,
            }}
          ></div>
          <Link
            className="breezy-home-btn"
            to={getBattlePass.getUrl}
            dangerouslySetInnerHTML={{
              __html: t(
                getBattlePass?.props[language]?.homeBtn || 'breezy-home-btn',
              ),
            }}
          />
        </div>
      </section>
    </>
  );
};
